export const chatTypography = {
  chartTick: {
    fontSize: 11,
    fontFamily: "var(--font-Medium)",
  },
  chartLabel: {
    fontSize: 10,
    fontFamily: "var(--font-Medium)",
    letterSpacing: "0.04em",
  },
  chartValue: {
    fontSize: 12,
    fontFamily: "var(--font-Regular)",
  },
} as const;
